<template>
  <div id="wo">
    <div class="commonContainer">
      <div>
        <div class="filterConditionContainer">
          <el-card class="box-card">
            <div class="filterCondition" >
              <div class="searchIcon">
                <i class="el-icon-search"></i>
              </div>
              <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px" v-if="!showFolderDetail">
                <el-form-item :label="$t('sourceMaterial.category')" >
                  <el-select v-model="filterForm.categoryId" :placeholder="$t('sourceMaterial.chooseCategory')" clearable>
                    <el-option
                      v-for="item in categoryOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.theme')" >
                  <el-select v-model="filterForm.topic" :placeholder="$t('sourceMaterial.chooseTheme')" clearable>
                    <el-option
                      v-for="item in themeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.season')" >
                  <el-select v-model="filterForm.season" :placeholder="$t('sourceMaterial.chooseSeason')" clearable>
                    <el-option
                      v-for="item in seasonOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="SKU" >
                  <el-input v-model="filterForm.sku" :placeholder="$t('sourceMaterial.enterSKU')"></el-input>
                </el-form-item>
              </el-form>
              <el-form :inline="true" :model="detailFilterForm" class="filterForm" label-width="98px" v-if="showFolderDetail">
                <el-form-item :label="$t('sourceMaterial.fileName')" >
                  <el-input v-model="detailFilterForm.fileName" :placeholder="$t('sourceMaterial.enterFileName')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.fileType')" >
                  <el-select v-model="detailFilterForm.fileType" :placeholder="$t('sourceMaterial.chooseFileType')" clearable>
                    <el-option
                      v-for="item in fileTypeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.uploadTime')" >
                  <el-date-picker
                    v-model="detailFilterForm.uploadTime"
                    type="date"
                    :placeholder="$t('sourceMaterial.chooseUploadTime')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="16">
                  <div class="filterBtns">
                    <!--
                    <el-button type="primary" @click="importData">导 入</el-button>
                    <el-button type="primary" @click="exportData">导 出</el-button>
                    -->
                    <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                    <el-button type="primary" v-if="!showFolderDetail" @click="onSearch('folder')">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail" @click="onSearch('detail')">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="!showFolderDetail" @click="onReset('filterForm')">{{ $t('reset') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail" @click="onReset('detailFilterForm')">{{ $t('reset') }}</el-button>

                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <div class="tableContainer">
          <el-card class="box-card">
            <div class="tableBox">
              <div class="orangeIcon">
                <i class="el-icon-s-order"></i>
              </div>
              <p class="title" @click="open13">
                13周日历
                <i class="el-icon-date"></i>
              </p>
            </div>
            <el-divider></el-divider>
            <div style="margin-top: 20px">
              <ul class="fileList" v-if="!showFolderDetail">
                <li v-for="(fileItem, index) in fileList" @click="fileItem.objectType === 0 ? openFolder(fileItem.uniqueId, fileItem.displayName) : () => {}">
                  <div style="text-align: center">
                    <i class="el-icon-folder fileIcon" v-if="fileItem.objectType === 0"></i>
                    <img :src="fileItem.objectUrl" alt="" style="width: 100%" v-if="fileItem.objectType !== 0">
                  </div>
                  <span>{{ fileItem.displayName }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadFile(fileItem.uniqueId, fileItem.displayName)"></i></el-col>
                  </el-row>
                </li>
              </ul>
              <ul class="fileList" v-if="showFolderDetail">
                <li v-for="(detailItem, index) in detailList1">
                  <el-checkbox v-model="detailList1[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <img src="http://placekitten.com/200/200" alt="" style="width: 100%">
                  </div>
                  <span>{{ detailItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteDetail(detailItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadDetail(detailItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
            </div>

          </el-card>
        </div>
      </div>
    </div>
    <el-dialog
      title="13周日历"
      :visible.sync="calendarDialogVisible"
      width="90%"
      center
    >
      <img :src="calendarUrl" alt="" style="width: 100%">
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { downloadFile } from "@/utils/tool";
export default {
  name: 'Wo',
  components: {
  },
  data: function () {
    return {
      calendarDialogVisible: false,
      calendarUrl: '', // 13周日历图片
      detailFilterForm: {
        fileName: '', // 文件名称
        fileType: '', // 文件类型
        uploadTime: '', // 上传时间
      },
      initDetailFilterForm: {
        fileName: '', // 文件名称
        fileType: '', // 文件类型
        uploadTime: '', // 上传时间
      },
      showFolderDetail: false,
      folderName: '',
      typeList: [
        'jpg',
        'jpeg',
        'png',
        'mp4',
        'xlsx',
        'pdf'
      ],
      uploadFileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
      newFileForm: {
        season: '', // 季节
        topic: '', // 主题
        sku: '', // sku
      },
      fileList: [
      ],
      chooseAllFiles1: false, // 全选素材
      chooseAllFiles2: false, // 全选素材
      chooseAllFiles3: false, // 全选素材
      chooseAllDetails1: false, // 全选
      chooseAllDetails2: false, // 全选
      chooseAllDetails3: false, // 全选
      activeName: 'first',
      uploadDialogVisible: false,
      CreateFileDialogVisible: false, // 新建文件夹弹窗
      themeOptions: [], // 主题列表
      seasonOptions: [], // 季节列表
      fileTypeOptions: [], // 文件类型列表
      filterForm: {
        categoryId: '', // 分类
        topic: '', // 主题
        season: '', // 季度
        sku: '', // sku
      },
      initFilterForm: {
        categoryId: '', // 分类
        topic: '', // 主题
        season: '', // 季度
        sku: '', // sku
      },
      categoryOptions: [],
      total: 0,
      tableConfig: {
        size: 1000, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
    }
  },
  mounted () {
    this.getOptions({})
    this.onReset()
    this.onReset('detailFilterForm')
  },
  methods: {
    deleteDetail () {
      // todo: 删除文件
    },
    downloadDetail () {
      // todo: 下载文件

    },
    // 查看文件夹详情
    openFolder: async function (id, name) {
      await this.onSearch(true, id)
      // this['showFolderDetail'] = true
      // this.folderName = name
    },

    downloadFile: async function (id, fileName) {
      let res = await window.instance.post(window.woUrl + '/resource/getBatchDownloadKey', {list: [id]})
      const downloadKey = res.data.data
      this.$tool.exportFile({
        url: window.woUrl + '/resource/downloadBatch?key=' + downloadKey,
        method: 'get'
      })
    },
    deleteFile: function () {
      // todo: 删除文件
    },
    saveFile: function () {
      // todo: 保存新建文件夹
    },
    downloadSourceMaterial: function() {
      // todo: 下载素材
    },
    uploadSourceMaterial: function() {
      this.uploadDialogVisible = true
    },
    patchDeleteFiles: function () {
      // todo: 批量删除文件夹
    },
    patchDeleteDetails: function () {
      // todo: 批量删除文件夹内的素材
    },
    onAddFile: function () {
      this.CreateFileDialogVisible = true
    },
    downloadFailure: function() {
      // todo: 下载导入失败列表
    },
    open13: async function() {
      let res = await window.instance.get(window.woUrl + '/resource/13weeks')
      res = res.data.data
      this.calendarUrl = res
      this.calendarDialogVisible = true
    },
    // 获取选项列表
    getOptions: async function () {
      let res = await window.instance.post(window.woUrl + '/filter/resource')
      res = res.data.data
      this.categoryOptions = _.map(res.categoryList, (category) => ({
        itemKey: category.key,
        itemValue: category.value
      }))
      this.themeOptions = _.map(res.topicList, (topic) => ({
        itemKey: topic.key,
        itemValue: topic.value
      }))
      this.seasonOptions = _.map(res.seasonList, (season) => ({
        itemKey: season.key,
        itemValue: season.value
      }))
    },
    onSearch: async function (resetPage, uniqueId) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      const submitParams = _.cloneDeep(this.filterForm)
      if(!_.isNil(uniqueId)) {
        submitParams.uniqueId = uniqueId
      }
      let res = await window.instance.post(window.woUrl + '/resource', _.assign(submitParams, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total = res.data.total
        this.fileList = list
      }
      this.tableLoading = false
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },

    // todo: 导入用户
    importData: function () {
      document.getElementById('importFileInput').value = ''
      // 如果失败的话,弹出失败列表
      this.failureDialogVisible = true
      this.failureTableData = [{
        name: '张三',
        role: '角色',
        cellphone: '13888888888',
        regionName: '大北京',
        resellerName: '客户',
        subResellerName: '二级客户',
        failureReason: '失败原因'
      }]
    },
    // todo: 导出用户
    exportData: function () {
    },
    getSelectedName: function (no, list) {
      if (!no) {
        return null
      }
      const selectedReseller = _.find(list, function (data) { return data.value === no })
      if (selectedReseller) {
        return selectedReseller.label
      } else {
        return false
      }
    }
  },
  watch: {
    chooseAllFiles1(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.fileList, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.fileList, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllFiles2(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.fileList2, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.fileList2, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllFiles3(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.fileList3, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.fileList3, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllDetails1(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.detailList1, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.detailList1, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllDetails2(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.detailList2, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.detailList2, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllDetails3(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.detailList3, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.detailList3, (file, index) => {
          file.checked = false
        })
      }
    }
  }
}
</script>

<style scoped lang="sass">
#wo
  .uploadBox
    border: 1px solid #ccc
    padding: 10px
    height: 400px
    margin-top: 20px
  .newFileIcon
    font-size: 120px
    color: #ff6801
  .filterConditionContainer
    margin-top: 30px
  .tableContainer
    .title
      position: absolute
      top: 0px
      left: 80px
      font-size: 16px
      text-decoration: underline
      color: #ff6801
    .fileList
      display: flex
      flex-wrap: wrap
      li
        width: calc(14.28% - 20px)
        margin-right: 20px
        margin-bottom: 20px
        background: #f1f1f1
        padding: 10px
        padding-bottom: 0
        position: relative
        label
          position: absolute
          right: 10px
          top: 7px

      .fileIcon
        font-size: 100px
        text-align: center
        color: #ff6801
      .el-icon-download
        color: #ff6801
        cursor: pointer
  .roleName
    color: #ff6801
    margin-left: 32px
    margin-bottom: 20px
  .roleCode
    margin-left: 32px
    margin-bottom: 14px
    label
      padding: 5px 0
</style>



// WEBPACK FOOTER //
// src/pages/information/wo.vue